module.exports = __webpack_public_path__ + "img/icon_lightning.708cabaa.svg";